import TuneIcon from '@mui/icons-material/Tune'
import { Button, ButtonProps } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useCurrentRefinements } from 'react-instantsearch'

export function ToggleFiltersButton(props: ButtonProps) {
  const { items } = useCurrentRefinements()
  const t = useTranslations('ToggleFiltersButton')

  const numberOfActiveFacets = items.length

  return (
    <Button
      {...props}
      variant="outlined"
      startIcon={<TuneIcon />}
      endIcon={
        <div className="flex aspect-square w-6 shrink-0 items-center justify-center rounded-full bg-mydra-black text-white">
          <span className="text-xs font-medium">{numberOfActiveFacets}</span>
        </div>
      }
    >
      {t('filters')}
    </Button>
  )
}
